import React from "react";
// import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Plus } from "lucide-react";
import DeploymentSummaryWidgets from "../components/Cards/DeploymentSummaryWidegets";
import DeploymentHistoryTable from "../components/Tables/DeploymentHistoryTable";
import "../styles/golive.css";

export default function RunListPage() {
  const navigate = useNavigate();

  return (
    <div className="gl-page">
      <div className="flex items-center justify-between flex-wrap gap-3">
        <div>
          <h1 className="text-2xl font-bold text-slate-900">Run History</h1>
          <p className="mt-0.5 text-sm text-slate-500">
            All deployment runs, newest first · auto-refreshes every 5 s
          </p>
        </div>
        <div className="flex gap-2">
          <button className="gl-btn primary" onClick={() => navigate("/golive/new")}>
            <Plus size={14} /> New Deployment
          </button>
        </div>
      </div>

      <DeploymentSummaryWidgets />
      <DeploymentHistoryTable />
    </div>
  );
}
